module.exports = __webpack_public_path__ + "img/map-marker-1.060d5140.svg";